module.exports = __webpack_public_path__ + "static/media/CT_2019_30447A.43f89b91.png";